import React from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';

const CounselorReviewDetails = (props) => {
   
    const {counRevDetails} = props;
    return (
        <div> 
            <Row>
                <Col lg={6}>
                    <p><strong>Applicant First Name:</strong></p>
                    <p>{counRevDetails.studentFirstName}</p>
                </Col>
                <Col lg={6}>
                    <p><strong>Applicant Last Name:</strong></p>
                    <p>{counRevDetails.studentLastName}</p>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Leadership:</strong></h4>
                    <p>{counRevDetails.leaderShip === "0" ? "N/A" : counRevDetails.leaderShip}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Perseverance Under Stress:</strong></h4>
                    <p>{counRevDetails.perseveranceUnderStress === "0" ?
                     "N/A" : counRevDetails.perseveranceUnderStress}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Reliability:</strong></h4>
                    <p>{counRevDetails.reliability === "0" ?
                     "N/A" : counRevDetails.reliability}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Cooperativeness:</strong></h4>
                    <p>{counRevDetails.cooperativeness === "0" ?
                     "N/A" : counRevDetails.cooperativeness}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Oral Communication:</strong></h4>
                    <p>{counRevDetails.oralCommunication === "0" ?
                     "N/A" : counRevDetails.oralCommunication}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Written Communication:</strong></h4>
                    <p>{counRevDetails.writtenCommunication === "0" ?
                     "N/A" : counRevDetails.writtenCommunication}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Interpersonal Regard:</strong></h4>
                    <p>{counRevDetails.interpersonalRegard === "0" ?
                     "N/A" : counRevDetails.interpersonalRegard}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Value Orientation:</strong></h4>
                    <p>{counRevDetails.valueOrientation === "0" ?
                     "N/A" : counRevDetails.valueOrientation}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Flexibility:</strong></h4>
                    <p>{counRevDetails.flexibility === "0" ?
                     "N/A" : counRevDetails.flexibility}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Ethics:</strong></h4>
                    <p>{counRevDetails.ethics === "0" ?
                     "N/A" : counRevDetails.ethics}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Problem Solving:</strong></h4>
                    <p>{counRevDetails.problemSolving === "0" ?
                     "N/A" : counRevDetails.problemSolving}</p>
                </Col>
                <Col lg={6}>
                    <h4 className="mt-3 h5"><strong>Global Assessment:</strong></h4>
                    <p>{counRevDetails.globalAssessment=== "0" ?
                     "N/A" : counRevDetails.globalAssessment}</p>
                </Col>

            </Row>
            <hr />
            <Row>
                <Col lg={12}>
                    <p className="mb-0"><strong>Comments:</strong></p>
                    <p>{counRevDetails.comments}</p>
                </Col>
                <Col lg={6}>
                    <p><strong>Filled by First Name:</strong></p>
                    <p>{counRevDetails.filledByFirstName}</p>
                </Col>
                
                <Col lg={6}>
                    <p><strong>Filled by Last Name:</strong></p>
                    <p>{counRevDetails.filledByLastName}</p>
                </Col>
                <Col lg={6}>
                    <p><strong>Email:</strong></p>
                    <p>{counRevDetails.counselorEmail}</p>
                </Col>
                <Col lg={6}>
                    <p><strong>Filled by Title:</strong></p>
                    <p>{counRevDetails.filledByTitle}</p>
                    
                </Col>
                <Col lg={6}>
                    <p><strong>Filled by Date:</strong></p>
                    <p>{counRevDetails.filledByDate ? 
                    moment(counRevDetails.filledByDate).format('MM/DD/YYYY'):""}</p>
                </Col>
                <Col lg={6}>
                    <p><strong>How long have you know this student?</strong></p>
                    <p>{counRevDetails.studentKnownFrom}</p>
                </Col>
                
            </Row>

        </div>
    );
}

export default CounselorReviewDetails;